import styled from "styled-components";

export const UiEditGroup = styled.div`
	display: flex;
	justify-content: flex-end;
`;
